module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/react-router-dom/node_modules/isarray/index.js
// module id = 732
// module chunks = 0 1 2 3 5 6